
import DataTable from "react-data-table-component"
import Cargando from "../components/Cargando"
import useHistorialVacacionesAdmin from "../hooks/useHistorialVacacionesAdmin"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { Button, Form, Modal } from "react-bootstrap"
import { Toaster } from "react-hot-toast"
// import { formatearFechaSpanish } from "../functions/formatearFecha"


export default function HistorialVacacionesAdmin() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { listaHistorial, cargando, buscar, setBuscar, elementosFiltrados,
        columns, handleClose, show, //vacacionesSeleccionadas, FechaVacaciones,
        setVacacionesEditar, vacacionesEditar, guardar, guardando } = useHistorialVacacionesAdmin()


    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }


    const TextRegistros = () => {
        if (elementosFiltrados.length === 0) {
            return <p className="lead py-2">No hay registros para mostrar</p>
        } else if (elementosFiltrados.length === 1) {
            return <p className="lead py-2">Mostrando 1 registro</p>
        } else {
            return <p className="lead py-2">Mostrando {elementosFiltrados.length} registros</p>
        }
    }


    // const TablaModal = ({ vacacionesSeleccionadas }) => {
    //     return (
    //         <Table>
    //             <tbody>
    //                 <tr>
    //                     <th>Empleado</th>
    //                     <td>{vacacionesSeleccionadas.nombre_empleado}</td>
    //                 </tr>
    //                 <tr>
    //                     <th>Mes seleccionado</th>
    //                     <td>{vacacionesSeleccionadas.fecha_propuesta}</td>
    //                 </tr>
    //                 <tr>
    //                     <th>Fecha de solicitud</th>
    //                     <td>{formatearFechaSpanish(vacacionesSeleccionadas.fecha_solicitud)}</td>
    //                 </tr>
    //                 <tr>
    //                     <th>Inicio de vacaciones</th>
    //                     <td><FechaVacaciones fecha={vacacionesSeleccionadas.inicio_vacaciones} /></td>
    //                 </tr>
    //                 <tr>
    //                     <th>Fin de vacaciones</th>
    //                     <td><FechaVacaciones fecha={vacacionesSeleccionadas.fin_vacaciones} /></td>
    //                 </tr>
    //             </tbody>
    //         </Table>
    //     )
    // }


    function FormAsignarVacaciones() {
        return (
            <>
                <Form>
                    <Form.Group className="mb-3" controlId="inicioVacaciones">
                        <Form.Label>Inicio de vacaciones</Form.Label>
                        <Form.Control type="date" value={vacacionesEditar.inicio_vacaciones} onChange={e => setVacacionesEditar({ ...vacacionesEditar, inicio_vacaciones: e.target.value })}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="finVacaciones">
                        <Form.Label>Fin de vacaciones</Form.Label>
                        <Form.Control type="date" value={vacacionesEditar.fin_vacaciones} onChange={e => setVacacionesEditar({ ...vacacionesEditar, fin_vacaciones: e.target.value })}/>
                    </Form.Group>
                </Form>
            </>
        )
    }


    return (
        <div>

            <TextRegistros />

            <Cargando cargando={cargando} />

            <div className="col-12 col-md-4">
                <input
                    type='search'
                    value={buscar}
                    className='form-control mb-2'
                    onChange={e => setBuscar(e.target.value)}
                    placeholder='Buscar por empleado, mes o fecha'
                />
            </div>

            {listaHistorial.length > 0
                && (<DataTable
                    responsive
                    pagination
                    columns={columns}
                    data={elementosFiltrados}
                    noDataComponent='No hay datos para mostrar'
                    progressPending={cargando}
                    highlightOnHover
                    paginationComponentOptions={{
                        rowsPerPageText: 'Filas por página:',
                        rangeSeparatorText: 'de',
                        selectAllRowsItem: true,
                        selectAllRowsItemText: 'Todos',
                        pageText: 'Página'
                    }}
                /> || <p className='lead text-center'>No hay datos para mostrar</p>)}



            {/* modal */}
            <Modal size="" show={show} onHide={handleClose}>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Asignar vacaciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className="row">
                        <div className="col-12 col-lg-6">
                            <div className="px-4">
                                <TablaModal vacacionesSeleccionadas={vacacionesSeleccionadas} />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="">
                            </div>
                        </div>
                    </div> */}
                    <FormAsignarVacaciones />
                </Modal.Body>
                <Modal.Footer className="border-0 d-flex justify-content-between">
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={guardar} disabled={guardando}>
                        { guardando ? 'Guardando...' : 'Guardar cambios' }
                    </Button>
                </Modal.Footer>
            </Modal>


            <Toaster />
        </div>
    )
}

